
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mall/[id]",
      function () {
        return require("private-next-pages/mall/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mall/[id]"])
      });
    }
  